import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { externalLink } from '../../../configs/externalLink'
import { Element } from '../../common/html/element'
import { Separator } from '../../common/separator'
import EventEmitter, { DISABLE_FOOTER } from '../../helpers/EventEmitter'
import { Content } from './Content'
import classes from './index.module.scss'
import './lang/i18n'

export const Footer = () => {
  const [isShow, setShow] = useState(true)

  const locale = useSelector((state) => state.i18n.locale)

  const renderLink = (label, route) => {
    return (
      <a href={route} target="_blank" rel="noopener noreferrer">
        <Element
          elementName="span"
          className={classes.item}
          style={{ color: '#2C73E8' }}
        >
          <Translate value={label} />
        </Element>
      </a>
    )
  }

  useEffect(() => {
    const eventAction = (data) => {
      setShow(data.isShow)
    }

    EventEmitter.subscribe(DISABLE_FOOTER, eventAction)
    return () => {
      EventEmitter.unsubscribe(DISABLE_FOOTER, eventAction)
    }
  }, [])

  return (
    <Element
      className={classes.container}
      style={{ backgroundColor: '#e5e5e8', display: isShow ? 'flex' : 'none' }}
    >
      <div className={classes.content}>
        <Translate value="layout.footer.TITLE1" className="fstItalic" />
        <Translate value="layout.footer.TITLE2" className="fstItalic" />
        <div className={classes.link}>
          <div className={classes.item}>
            <Content />
          </div>
          {renderLink(
            'layout.footer.PRIVACY_POLICY',
            externalLink.PRIVACY_POLICY[locale],
          )}
          <Separator width={1} height={16} backgroundColor="#9C9C9C" />
          {renderLink(
            'layout.footer.TERMS_OF_USE',
            externalLink.TERMS_OF_USE[locale],
          )}
          <Separator width={1} height={16} backgroundColor="#9C9C9C" />
          {renderLink(
            'layout.footer.DATA_POLICY',
            externalLink.DATA_POLICY[locale],
          )}
        </div>
      </div>

      <Element
        className={classes.footer}
        style={{ backgroundColor: '#0553A5' }}
      />
    </Element>
  )
}
